import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_get_physical_inventory_by_license_plate_lot_by_project_idService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, Amount?: number, GrossVolume?: number, GrossWeight?: number, NetVolume?: number, NetWeight?: number, PackagedAmount?: number, VolumeUomId?: number, WeightUomId?: number, Lot?: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, Notes?: string, ReceiveDate?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Status?: { Name?: string } }, Status?: { Name?: string }, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string } }, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, LicensePlate?: { Id?: number, DimensionsUomId?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, WarehouseId?: number, Width?: number, Status?: { Name?: string }, Location?: { Id?: number, Name?: string, Status?: { Name?: string } } } }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, Amount?: number, GrossVolume?: number, GrossWeight?: number, NetVolume?: number, NetWeight?: number, PackagedAmount?: number, VolumeUomId?: number, WeightUomId?: number, Lot?: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, Notes?: string, ReceiveDate?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Status?: { Name?: string } }, Status?: { Name?: string }, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string } }, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, LicensePlate?: { Id?: number, DimensionsUomId?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, WarehouseId?: number, Width?: number, Status?: { Name?: string }, Location?: { Id?: number, Name?: string, Status?: { Name?: string } } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[], $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, Amount?: number, GrossVolume?: number, GrossWeight?: number, NetVolume?: number, NetWeight?: number, PackagedAmount?: number, VolumeUomId?: number, WeightUomId?: number, Lot?: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, Notes?: string, ReceiveDate?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Status?: { Name?: string } }, Status?: { Name?: string }, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string } }, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, LicensePlate?: { Id?: number, DimensionsUomId?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, WarehouseId?: number, Width?: number, Status?: { Name?: string }, Location?: { Id?: number, Name?: string, Status?: { Name?: string } } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[]    }) {
      return false;
    }
}
